import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ScribeLink from './ScribeLink';
import { scribeDocumentBase, parentContainer } from './ScribePropTypes';
import { isExternalUrl } from './ScribeLinkUtils';
import GraphicPageComponent from 'apps/analytics/components/GraphicPageComponent';
import { sendAdvertAnalytics } from 'apps/analytics';
import GraphicImpression from 'apps/gtm/containers/GraphicImpression';
import impressionTypes from 'apps/gtm/utils/gtmImpressionTypes';

export default class RhsBanner extends PureComponent {
  static propTypes = {
    banner: PropTypes.shape({
      ...scribeDocumentBase,
      imageSrc: PropTypes.string.isRequired,
      imageAlt: PropTypes.string,
      url: PropTypes.string.isRequired,
    }).isRequired,
    ...parentContainer,
  };

  sendAnalytics = () => {
    sendAdvertAnalytics(this.props.banner, this.props.parentContainer);
  };

  render() {
    const { banner: { url, imageSrc, imageAlt } } = this.props;
    const {
      banner: { docNo, docVersionNo, docTitle },
      parentContainer: { docNo: parentNo, docVersionNo: parentVersionNo, docTitle: parentTitle },
    } = this.props;
    const target = isExternalUrl(url) ? { target: '_blank', rel: 'noopener noreferrer' } : null;
    const id2 = `${docNo}-${docVersionNo}-${parentNo}-${parentVersionNo}`;

    return (
      <div id="rhsBanner" className="sidebarBox show-for-xlarge">
        <GraphicPageComponent
          docNo={docNo}
          docVersionNo={docVersionNo}
          parentNo={parentNo}
          parentVersionNo={parentVersionNo}
          description="RHS_BANNER"
        />
        <GraphicImpression
          id={docNo}
          id2={id2}
          name={docTitle}
          creative={parentTitle}
          position={impressionTypes.RHS_BANNER}
        />
        <ScribeLink to={url} {...target} onClick={this.sendAnalytics}>
          <img src={imageSrc} alt={imageAlt} />
        </ScribeLink>
      </div>
    );
  }
}

